import {Component} from "@angular/core";
import {TabsPageContainer} from "../../../uiComponents/tabsPageContainer";

@Component({
	selector: 'inbound-shield-tabs',
	templateUrl: './inbound-shield-tabs.component.html',
})
export class InboundShieldTabsComponent extends TabsPageContainer {
	tabWidth = 170;

	hiddenTabs = new Set(['scanThreats']);

	tabLabels: {[key: string]: string} = {
		securityAwareness: 'Security Banners',
	};

	getVisibleTabIndex(tabName: string): number {
		return Object.entries(this.dic.CONSTANTS.inboundShieldSettingsPageTabs)
			.filter(([key]) => !this.hiddenTabs.has(key))
			.map(([, value]) => value)
			.indexOf(tabName);
	}
}
